import { useAppNotification } from "@hooks/useAppNotification";
import { AppNotificationModal } from "./AppNotificationModal";

export function FirstWebsiteNotification() {
  const { notification, dismiss, close, isDismissing } =
    useAppNotification("first_website");

  if (!notification) return null;

  return (
    <AppNotificationModal
      open
      onClose={close}
      onDismiss={dismiss}
      isDismissing={isDismissing}
      title="Houston is building your website."
      description="Afterwards, you can:"
    >
      <div className="space-y-5">
        <div className="flex gap-4 text-sm text-[#2e3238]">
          <div className="flex flex-col items-center gap-1">
            <span className="flex-shrink-0 w-6 h-6 rounded-full bg-[#0f1113] flex items-center justify-center text-xs font-semibold text-white">
              1
            </span>
            <div className="w-px flex-1 bg-[#e0dfdd]" />
          </div>
          <div className="pb-4">
            <span className="font-medium text-[#0f1113]">Ask me to change anything</span>
            <p className="text-[#74767a] text-xs mt-0.5">Layout, copy, colors, images, sections — just describe what you want in the chat.</p>
          </div>
        </div>
        <div className="flex gap-4 text-sm text-[#2e3238] -mt-3">
          <div className="flex flex-col items-center gap-1">
            <span className="flex-shrink-0 w-6 h-6 rounded-full bg-[#0f1113] flex items-center justify-center text-xs font-semibold text-white">
              2
            </span>
            <div className="w-px flex-1 bg-[#e0dfdd]" />
          </div>
          <div className="pb-4">
            <span className="font-medium text-[#0f1113]">Ask for additional pages, sections, or links</span>
            <p className="text-[#74767a] text-xs mt-0.5">Want an FAQ page? Link to an external website? Anything you want - Houston can handle it.</p>
          </div>
        </div>
        <div className="flex gap-4 text-sm text-[#2e3238] -mt-3">
          <div className="flex flex-col items-center">
            <span className="flex-shrink-0 w-6 h-6 rounded-full bg-[#0f1113] flex items-center justify-center text-xs font-semibold text-white">
              3
            </span>
          </div>
          <div>
            <span className="font-medium text-[#0f1113]">Deploy your website</span>
            <p className="text-[#74767a] text-xs mt-0.5">Claim a free Launch10 subdomain or connect your own.</p>
          </div>
        </div>

        <div className="bg-[#f7f6f4] rounded-lg px-4 py-3">
          <p className="text-sm text-[#2e3238]">
            <span className="font-medium">I'm not just a builder — I'm a strategist.</span>{" "}
            Ask me "Is this headline strong enough?" or "What should my CTA say?" and I'll give you real advice.
          </p>
        </div>
      </div>
    </AppNotificationModal>
  );
}
